export default __webpack_public_path__ + "static/icon-andy-signature-55a6818575d049f7d911073c34b71f9f.png";